"use client";
import React from "react";

interface RFIDData {
  ticketNumber: string;
  cardAmount: number;
  customerMobileNumber: string;
  customerName: string;
  numberOdAdults: string;
  numberOfChildren: string;
  totalMembers: string;
  ticketBookingId: number;
  ticketUniqueId: string;
  cardAssignId: number;
}
interface TicketDetailsProps {
  rfidData: RFIDData | null;
}

const TicketDetails = ({ 
  rfidData,
}: TicketDetailsProps) => {
  return (
    <aside className="border border-5 border-warning bg-light text-dark small px-4 pt-4 pb-5 mt-3 w-100">
      <h2 className="text-center fw-semibold fs-5 mb-3">Ticket Details</h2>

      <div className="mx-auto" style={{ maxWidth: "200px" }}>
        <p>Ticket No.-{rfidData?.ticketNumber}</p>
        <p className="mt-2">Customer Name-{rfidData?.customerName}</p>
        <p className="mt-2">Customer Number-{rfidData?.customerMobileNumber}</p>
        <p className="mt-2">Total Members - {rfidData?.totalMembers}</p>
        <p className="mt-2">No. of Adults - {rfidData?.numberOdAdults}</p>
        <p className="mt-2">No. of Kids - {rfidData?.numberOfChildren}</p>
        <p className="mt-2">Card Assign - xxxxxxxxxxxxxxxxx</p>
        {/* <p className="mt-2">Select Card ID - 6754321890</p>
        <p className="mt-2">Balance - 1000</p>
        <p className="mt-2">Date - 1000</p> */}
      </div>

      {/* <div className="mt-4">
        <img
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/12cb90b41edbdf51c86486599496396bc3330243?placeholderIfAbsent=true&apiKey=155088335b9245cc9e899591d6dc52ea"
          alt="Divider"
          className="img-fluid"
        />
      </div>

      <div className="mt-4">
        <img
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/56be7d9c2860d9664df1baa585252c52e8374bed?placeholderIfAbsent=true&apiKey=155088335b9245cc9e899591d6dc52ea"
          alt="Divider"
          className="img-fluid"
        />
      </div> */}

      {/* <div
        className="d-flex justify-content-between mt-4 mx-auto"
        style={{ maxWidth: "250px" }}
      >
        <div>
          <h5 className="fw-semibold">TRF ID</h5>
          <p className="mt-3">23456781</p>
          <p className="mt-2">23456781</p>
          <p className="mt-2">23456781</p>
        </div>
        <div>
          <h5 className="fw-semibold">RF ID</h5>
          <p className="mt-3">RF ID-1</p>
          <p className="mt-2">RF ID-2</p>
          <p className="mt-2">RF ID-3</p>
        </div>
      </div> */}
    </aside>
  );
};

export default TicketDetails;
